import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import Button from '../ui/Button';
import { IArticle } from './forPages/forHome/NewsBlock';
import { dateFromISO } from '@/services/dates.service';

export default function Catalogue({article}: {article: IArticle}) {
  return <Container>
    <ImageBox>
      <Image src={article.img} alt={article.name} fill
             sizes="(max-width: 820px) 100vw, 50vw"
             style={{ objectFit: 'cover' }} />
    </ImageBox>
    <TextBox>
      <Date>{dateFromISO(article.modif_date)}</Date>
      <Title>{article.name}</Title>
      <Text>{article.short_text}</Text>
      <Button color="transparent" href={`/articles/item/${article.id}`}>Подробнее</Button>
    </TextBox>
  </Container>
}

const Container = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-column-gap: 30px;

  @media (max-width: 820px) {
    grid-template-columns: 100%;
    grid-row-gap: 20px;
  }

  /* @media (max-width: 480px) {
    grid-template-columns: 100%;
    grid-row-gap: 20px;
  } */
`

const TextBox = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  line-height: normal;

  & a {
    margin-top: auto;
  }
`

const Date = styled.div`
  font-family: var(--font-light);
  margin-bottom: 5px;
`

const Title = styled.h3`
  font-size: 24px;
  font-family: var(--font-semibold);
  color: var(--color-title);
  margin: 0 0 10px;

  & strong {
    color: var(--red);
  }
`

const Text = styled.div`
  margin-bottom: 20px;
  line-height: 21px;
`

const ImageBox = styled.div`
    position: relative;
    min-height: 220px;
`
